<template>
  <div class="size-controller-wrapper me-12">
    <label class="mb-4">{{ label }}</label>
    <div class="color-pallete-selector d-flex">
      <div class="color-box-wrapper me-12">
        <span
          :style="getTypedColor"
          class="color-box bm-small-btns d-block"
          @click.stop="toggle" />
      </div>
      <div class="">
        <input
          ref="colorInput"
          :class="[isValid ? 'warning-border':'']"
          :value="getColorHexCode"
          maxlength="9"
          type="text"
          class="fs-14 text-dark-gray  py-6 px-13 text-center  color-code color-code-wrapper  d-inline-flex align-items-center justify-content-center  border border-light-gray rounded rounded-4  bg-white"
          @keyup.enter="updateColorfromInput">

      </div>

    </div>
  </div>
</template>
<script>
import ColorPicker from '@/components/ColorPicker/ColorPicker';
import { cmykToHex, rgbToHex } from '@/components/Helper';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes'; // TDOD: Change to @/
import chroma from 'chroma-js';


export default {
  name:       'ColorSelector',
  components: { 'color-picker': ColorPicker },
  props:      {
    label:       String,
    colorobject: [Object, String],
    // onchangeFontColor: Function,
  },
  data() {
    return {
      color:   this.colorobject,
      isValid: false,
    };
  },
  computed: {
    getColorHexCode() {
      return chroma(this.color).hex('rgb');
    },

    getTypedColor() {
      const hexColor =  chroma(this.color).hex('rgb');
      return { backgroundColor: `${hexColor}` };
    },

    setBorder() {
      let hexColor =  this.color;
      hexColor     = this.color.startsWith('rgb') && rgbToHex(hexColor);
      if (hexColor.length === 7) {
        return { borderColor: `${hexColor} !important` };
      }
    },
  },

  methods: {
    updateColorfromInput(e) {
      const value = e.target.value;
      if (chroma.valid(value)) {
        this.color = chroma(value).hex();
        this.updateColor();
      }
    },
    toggle() {
      if (this.$store.state.colorpicker.isopen == false) {
        this.$store.commit('setIsOpen', true);
      } else {
        this.$store.commit('setIsOpen', false);
      }
    },
    updateColor() {
      if (chroma.valid(this.color)) {
        this.isValid = false;
        const Hex    = chroma(this.color).hex();
        const Rgba   = chroma(this.color).rgba();
        const CMYK   = chroma(this.color).cmyk();
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_COLOR, Hex, Rgba, CMYK);
      } else {
        this.isValid = true;
      }

      // this.onchangeFontColor(Hex, Rgba, CMYK);
    },
  },
};

</script>
<style scoped lang="scss">
  .color-code-wrapper {
    &.color-code{
      width: 84px;
      height: 36px;
      max-width: 100%;
    }
  }

  .warning-border{
    border:1px solid #dc3545 !important;
  }

</style>
